import React from "react";
import { ArrowUpRight } from "lucide-react";
import { FOOTER } from "@/constants/testIds";
import { INTAKE_URL } from "@/constants/links";

const LOGO =
  "https://customer-assets.emergentagent.com/job_integrated-wellness-6/artifacts/amgkh1mp_logo.png";

export default function Footer() {
  return (
    <footer
      data-testid={FOOTER.root}
      className="border-t border-[color:var(--iw-border)] bg-white text-[color:var(--iw-primary)]"
    >
      {/* Top CTA strip */}
      <div className="border-b border-[color:var(--iw-border)] bg-[color:var(--iw-bg)]">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-6 px-5 py-12 sm:px-8 lg:flex-row lg:items-center">
          <h3 className="font-display text-2xl font-semibold tracking-tight text-[color:var(--iw-primary)] sm:text-3xl lg:max-w-2xl">
            Ready to start?{" "}
            <span className="text-[color:var(--iw-blue)]">One form. One reply. One business day.</span>
          </h3>
          <a
            href={INTAKE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={FOOTER.ctaApply}
            className="iw-btn-red inline-flex flex-shrink-0 items-center gap-2 px-7 py-4 font-mono text-[12px] uppercase tracking-[0.22em] sm:text-[13px]"
          >
            Get Started <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </div>

      {/* Slim bottom bar */}
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-4 px-5 py-8 sm:flex-row sm:items-center sm:px-8">
        <div className="flex items-center gap-3">
          <img
            src={LOGO}
            alt="Integrated Wellness logo"
            className="h-10 w-10 rounded-full object-cover ring-1 ring-[color:var(--iw-border)]"
            decoding="async"
            loading="lazy"
            width="40"
            height="40"
          />
          <div className="leading-tight">
            <div className="font-display text-base font-semibold text-[color:var(--iw-primary)] sm:text-lg">
              Integrated Wellness
            </div>
          </div>
        </div>
        <div className="font-mono text-[12px] uppercase tracking-[0.22em] text-[color:var(--iw-muted-foreground)]">
          © {new Date().getFullYear()} Integrated Wellness · All rights reserved
        </div>
      </div>

      {/* Required wellness/medical disclaimer — appears on every page */}
      <div className="border-t border-[color:var(--iw-border)] bg-[color:var(--iw-bg)]">
        <div className="mx-auto max-w-7xl px-5 py-8 sm:px-8">
          <p className="text-[13px] leading-relaxed text-[color:var(--iw-muted-foreground)] sm:text-[14px]">
            <strong className="text-[color:var(--iw-primary)]">Health &amp; wellness programs — not medical advice.</strong>{" "}
            Integrated Wellness Optimization Programs provide coaching, lifestyle, and wellness support. They do not diagnose, treat, cure, or prevent any disease, and they are not a substitute for medical care. Body-composition, biological-age, and other engine outputs are wellness estimates for tracking trends — not diagnostic or medical-grade measurements. Results vary and are not guaranteed. Always consult a qualified healthcare professional before starting any new diet, exercise, or supplement program. Medical services, where referenced, are provided separately by the licensed Integrated Medical team.
          </p>
        </div>
      </div>
    </footer>
  );
}
